import { ViewConfig } from "@lib/views";
import type { SendingDomainResponse } from "@common/schemas/sending-domain.schema";
import type { ViewTableMeta } from "@design-system/ViewTable/ViewTable.lib";
import { DomainCell } from "./cells/DomainCell";
import { MethodCell } from "./cells/MethodCell";
import { SendingDomainActionsCell } from "./cells/SendingDomainActionsCell";
import { StatusCell } from "./cells/StatusCell";

export enum SendingDomainColumn {
    DOMAIN = "domain",
    METHOD = "method",
    STATUS = "status",
    ACTIONS = "actions",
}

export const SUGGESTED_SENDING_DOMAIN_ROW_ID = "suggested-custom-domain";

export interface SuggestedSendingDomainRow {
    id: typeof SUGGESTED_SENDING_DOMAIN_ROW_ID;
    domain: string;
    isSuggested: true;
}

export interface SendingDomainsTableCallbacks {
    onConnectDomain: (domain: string) => void;
}

export type SendingDomainsTableMeta = ViewTableMeta<
    SendingDomainsTableCallbacks,
    unknown
>;

export type SendingDomainRow =
    | SendingDomainResponse
    | SuggestedSendingDomainRow;

export function isSuggestedSendingDomainRow(
    row: SendingDomainRow,
): row is SuggestedSendingDomainRow {
    return "isSuggested" in row && row.isSuggested;
}

export const sendingDomainsViewConfig: ViewConfig<
    SendingDomainRow,
    SendingDomainColumn,
    never
> = {
    columns: {
        [SendingDomainColumn.DOMAIN]: {
            accessorKey: "domain",
            name: "Domain",
            header: "Domain",
            cell: DomainCell,
            minSize: 180,
            maxSize: 1000,
        },
        [SendingDomainColumn.METHOD]: {
            accessorKey: "method",
            name: "Method",
            header: "Method",
            cell: MethodCell,
            minSize: 90,
            maxSize: 120,
        },
        [SendingDomainColumn.STATUS]: {
            accessorKey: "status",
            name: "Status",
            header: "Status",
            cell: StatusCell,
            minSize: 110,
            maxSize: 160,
        },
        [SendingDomainColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: SendingDomainActionsCell,
            align: "right",
            minSize: 100,
            maxSize: 120,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
